import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import Index from "./pages/Index.tsx";
import Privacy from "./pages/Privacy.tsx";
import Terms from "./pages/Terms.tsx";
import RecoveryGuide from "./pages/RecoveryGuide.tsx";
import NotFound from "./pages/NotFound.tsx";
import Embed from "./pages/Embed.tsx";
import GbpPosts from "./pages/admin/GbpPosts.tsx";
import ClinicSettings from "./pages/admin/ClinicSettings.tsx";
import EmbedSnippets from "./pages/admin/EmbedSnippets.tsx";
import Auth from "./pages/Auth.tsx";
import RequireAdmin from "./components/admin/RequireAdmin";
import CookieNotice from "./components/clinic/CookieNotice";
import SiteSchema from "./components/SiteSchema";
import NapAuditBadge from "./components/NapAuditBadge";
import NapSchemaDriftWarning from "./components/NapSchemaDriftWarning";
import ClinicSettingsBootstrap from "./components/ClinicSettingsBootstrap";
import { isEmbedMode } from "./lib/embed";

const queryClient = new QueryClient();

const App = () => {
  const embedded = isEmbedMode();
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <ClinicSettingsBootstrap />
        <SiteSchema />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/embed" element={<Embed />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route
              path="/blepharoplasty-recovery-guide"
              element={<RecoveryGuide />}
            />
            <Route path="/auth" element={<Auth />} />
            <Route
              path="/admin/gbp-posts"
              element={
                <RequireAdmin>
                  <GbpPosts />
                </RequireAdmin>
              }
            />
            <Route
              path="/admin/clinic-settings"
              element={
                <RequireAdmin>
                  <ClinicSettings />
                </RequireAdmin>
              }
            />
            <Route
              path="/admin/embed"
              element={
                <RequireAdmin>
                  <EmbedSnippets />
                </RequireAdmin>
              }
            />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
          {/* Hide chrome that doesn't belong inside someone else's iframe. */}
          {!embedded && (
            <>
              <CookieNotice />
              <NapAuditBadge />
              <NapSchemaDriftWarning />
            </>
          )}
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;
